module.exports = __webpack_public_path__ + "static/home-c3830a04be30808076221a5b6f32053e.png";